export default __webpack_public_path__ + "static/media/Draft Icon.652df938.svg";